import React from 'react'

export default function ClickBlockOverlay(props: { background?: string }) {
  return (
    <div
      onClick={e => e.stopPropagation()}
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 1000,
        background: props.background,
      }}
    />
  )
}
